import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormErrorComponent implements OnInit {
  control = input<AbstractControl | null>(null);
  errorMessage$!: Observable<string>;

  ngOnInit() {
    const control = this.control();
    if (control) {
      this.errorMessage$ = control.statusChanges.pipe(
        startWith(control.status),
        map(() => this.getErrorMessage())
      );
    }
  }

  getErrorMessage(): string {
    const control = this.control();
    if (!control) return '';

    if (control.touched || control.dirty) {
      if (control.hasError('required')) return 'Ce champ est requis';
      if (control.hasError('email')) return 'Adresse email invalide';
    }

    if (control.hasError('httpError')) return control.getError('httpError');

    return '';
  }
}
